import { GlAlert, GlLink, GlSprintf } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { helpPagePath } from '~/helpers/help_page_helper';
import { getGroupTransferLocations, transferGroup } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/api/groups_api.js?vue3';
import { __, s__, sprintf } from '~/locale';
import { createAlert } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/alert.js?vue3';
import TransferModal from '/builds/gitlab/gitlab-ee/app/assets/javascripts/groups_projects/components/transfer_modal.vue?vue3';
export default {
    name: 'TransferGroupModal',
    components: {
        TransferModal,
        GlAlert,
        GlLink,
        GlSprintf
    },
    provide () {
        return {
            resourceId: String(this.group.id),
            resourcePath: this.group.path,
            resourceFullPath: this.group.fullPath
        };
    },
    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        group: {
            type: Object,
            required: true
        }
    },
    emits: [
        'change',
        'success'
    ],
    computed: {
        additionalDropdownItems () {
            return [
                {
                    id: null,
                    humanName: __('No parent group'),
                    newPath: this.group.path
                }
            ];
        },
        title () {
            return sprintf(s__('NamespaceTransfer|Transfer - %{name}'), {
                name: this.group.name
            });
        }
    },
    methods: {
        handleError (error) {
            createAlert({
                message: error || s__('NamespaceTransfer|An error occurred while transferring the group. Please refresh the page to try again.'),
                captureError: true,
                error
            });
        }
    },
    getGroupTransferLocations,
    transferGroup,
    transferDocsPath: helpPagePath('user/group/manage', {
        anchor: 'transfer-a-group'
    })
};
